import { castArray, intersection, isArray, isEmpty } from 'lodash'

import useLoggedInUser from './use-logged-in-user'

const useUserHasPermissions = permissions => {
  const permissionsArray = isArray(permissions)
    ? permissions
    : castArray(permissions)

  const loggedInUser = useLoggedInUser()

  return !isEmpty(intersection(loggedInUser?.permissions, permissionsArray))
}

export default useUserHasPermissions
